(function TripSummaryFilter($, Adzuki)
{
	'use strict';

	const component = {
		emits   : ['updated'],
		template: '#ts-filter',
		inject  : ['getFaIconStyle'],
		props   : {
			allTypes: {
				type    : Array,
				required: true,
				default : [],
			},
			allStatuses: {
				type    : Array,
				required: true,
				default : [],
			},
			currentTab: {
				type    : String,
				required: true,
				default : 'active',
			},
		},
		data() {
			return {
				populated     : false,
				currentKeyword: '',
				keywords      : [],
				clients       : [],
				types         : [],
				statuses      : [],
				destinations  : [],
				startDate     : null,
				endDate       : null,
			};
		},
		methods: {
			addClient(client) {
				if (client.trim() === '') {
					return;
				}

				if (this.clients.includes(client.trim())) {
					return;
				}

				this.clients.push(client);
			},
			addDestination(destination) {
				if (destination.trim() === '') {
					return;
				}

				if (this.destinations.includes(destination.trim())) {
					return;
				}

				this.destinations.push(destination);
			},
			addKeyword() {
				if (this.currentKeyword.trim() === '') {
					return;
				}

				if (this.keywords.includes(this.currentKeyword.trim())) {
					return;
				}

				this.keywords.push(this.currentKeyword.trim());
				this.currentKeyword = '';
			},
			emitUpdate() {
				this.populated = false;

				if (
					this.keywords.length > 0 ||
					this.clients.length > 0 ||
					this.types.length > 0 ||
					this.statuses.length > 0 ||
					this.destinations.length > 0 ||
					this.startDate ||
					this.endDate
				) {
					this.populated = true;
				}

				// validate start date and end date
				if (this.startDate && this.endDate) {
					const filterStartDate = new Date(this.startDate).getTime();
					const filterEndDate   = new Date(this.endDate).getTime();

					// the end date must be after the start date
					if (filterStartDate > filterEndDate) {
						Adzuki.StatusMessage('error', 'End date must be after start date');
					}
				}

				this.$emit('updated', {
					populated   : this.populated,
					keywords    : this.keywords,
					clients     : this.clients,
					types       : this.types,
					statuses    : this.statuses,
					destinations: this.destinations,
					startDate   : this.startDate,
					endDate     : this.endDate,
				});
			},
			removeClient(client) {
				this.clients = this.clients.filter((c) => c !== client);
			},
			removeDestination(destination) {
				this.destinations = this.destinations.filter((d) => d !== destination);
			},
			removeKeyword(keyword) {
				this.keywords = this.keywords.filter((k) => k !== keyword);
			},
			reset() {
				this.populated      = false;
				this.currentKeyword = '';
				this.keywords       = [];
				this.clients        = [];
				this.types          = [];
				this.statuses       = [];
				this.destinations   = [];
				this.startDate      = null;
				this.endDate        = null;
			},
			showStatus(status) {
				switch (status) {
					case 'approved':
						return this.currentTab === 'active' || this.currentTab === 'expired';
					case 'archived':
						return this.currentTab === 'archived';
					case 'returned':
						return this.currentTab === 'expired';
					case 'revision':
						return this.currentTab === 'active' || this.currentTab === 'expired';
					case 'review':
						return this.currentTab === 'active' || this.currentTab === 'expired';
					case 'upcoming':
						return this.currentTab === 'active';
					case 'traveling':
						return this.currentTab === 'active';
					default:
						return false;
				}
			},
		},
		watch: {
			populated() {
				this.emitUpdate();
			},
			keywords: {
				handler() {
					this.emitUpdate();
				},
				deep: true,
			},
			clients: {
				handler() {
					this.emitUpdate();
				},
				deep: true,
			},
			types: {
				handler() {
					this.emitUpdate();
				},
				deep: true,
			},
			statuses: {
				handler() {
					this.emitUpdate();
				},
				deep: true,
			},
			destinations: {
				handler() {
					this.emitUpdate();
				},
				deep: true,
			},
			startDate() {
				this.emitUpdate();
			},
			endDate() {
				this.emitUpdate();
			},
		},
		mounted() {
			// init client typeahead
			Adzuki.Typeahead($('#client-ta'), '/Clients/search', (client, $self) => {
				this.addClient(client.full_name.trim());
				$self.val('');
			});

			// init destination typeahead
			Adzuki.Typeahead($('#destination-ta'), '/Searches/destination/all', (destination, $self) => {
				this.addDestination(destination.name.trim());
				$self.val('');
			});
		},
	};

	Adzuki.VueComponents.TripSummaryFilter = component;
}(jQuery, window.Adzuki || {}));
